import axios from 'axios'

const API_URL = '/api/bowties/'

const authCfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } })

// Get bowties for a workspace ('personal' or an org slug)
const getBowties = async (token, workspace = 'personal') => {
    const response = await axios.get(API_URL, { ...authCfg(token), params: { workspace } })
    return response.data
}

// Create bowtie. bowtieData may carry { organisation: <slug|id> } to create it
// directly in an org workspace.
const createBowtie = async (bowtieData, token) => {
    const response = await axios.post(API_URL, bowtieData, authCfg(token))
    return response.data
}

const updateBowtie = async (bowtieData, token) => {
    const response = await axios.put(API_URL + bowtieData._id, bowtieData, authCfg(token))
    return response.data
}

// Delete bowtie
const deleteBowtie = async (bowtieId, token) => {
    const response = await axios.delete(API_URL + bowtieId, authCfg(token))
    return response.data
}

// Move a personal bowtie into an organisation (one-way).
const moveBowtieToOrg = async ({ bowtieId, organisation }, token) => {
    const response = await axios.patch(`${API_URL}${bowtieId}/workspace`, { organisation }, authCfg(token))
    return response.data
}

// Clone any viewable bowtie into the caller's personal workspace.
// Clone a bowtie. With `organisation` (slug or id) the copy lands in that org;
// otherwise in the caller's personal workspace. The source is untouched.
const cloneBowtie = async (bowtieId, token, organisation = null) => {
    const body = organisation ? { organisation } : {}
    const response = await axios.post(`${API_URL}${bowtieId}/clone`, body, authCfg(token))
    return response.data
}

const bowtiesService = {
    getBowties,
    createBowtie,
    updateBowtie,
    deleteBowtie,
    moveBowtieToOrg,
    cloneBowtie,
}

export default bowtiesService
